import axios from "axios";
import { globalErrorHandler } from "../Api";

export const PAYROLL_LOADING = "PAYROLL_LOADING";
export const GET_VACATIONS = "GET_VACATIONS";
export const GET_CAFETERIA = "GET_CAFETERIA";
export const GET_CAFETERIA_DETAIL = "GET_CAFETERIA_DETAIL";
export const GET_PAYLIST = "GET_PAYLIST";
export const GET_YEAR_BONUS = "GET_YEAR_BONUS";
export const RESET_STORAGE = "RESET_STORAGE";
export const ERROR = "ERROR";
export const GET_BONUS = "GET_BONUS";
export const RESET_BONUS = "RESET_BONUS"

export const GetVacations = (badge) => {
  const config = {
    headers: {
      "content-type": "application/json",
    },
  };
  return async (dispatch) => {
    dispatch({
      type: PAYROLL_LOADING,
    });
    await axios
      .get(
        //`/api/chatbot/vacations`,
        `https://sykesapifunc.azurewebsites.net/api/vacaciones?code=xGhyLo/nj5RqNKMCOxNp/TQt7v1gMIVj75i2IyUUPm9nTrW0vSaxvw==&codigo_alternativo=${badge}`,
        config
      )
      .then((res) => {
        dispatch({
          type: GET_VACATIONS,
          data: res.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: ERROR,
          data: error.message,
        });
      });
  };
};

export const GetCafeteria = (badge) => {
  const config = {
    headers: {
      "content-type": "application/json",
    },
  };
  return async (dispatch) => {
    dispatch({
      type: PAYROLL_LOADING,
    });
    await axios
      .post(
        //`/api/chatbot/cafeteria`,
        `https://prod.solaria.tech/erp/orders/getOrdersListClient?api_token=Rdzfso3HT8wg27waRMCiURkc6mF2J4cPlMWTaiC4jeWq6RO90ha1N1Okgac9`,
        { badgeUser: `01${badge}`, statusInvoice: "pending" },
        config
      )
      .then((res) => {
        dispatch({
          type: GET_CAFETERIA,
          data: res.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: ERROR,
          data: error.message,
        });
      });
  };
};

export const GetPaylist = (badge) => {
  const config = {
    headers: {
      "content-type": "application/json",
    },
  };
  return async (dispatch) => {
    dispatch({
      type: PAYROLL_LOADING,
    });
    await axios
      .get(
        //`/api/chatbot/payList`,
        `https://sykesapifunc.azurewebsites.net/api/salarios?code=Wi7jRq6YtwFRvch13amAF4QwKknpYXOPfcwo5i/7S8jfqBhbbFrRZQ==&codigo_alternativo=${badge}`,
        config
      )
      .then((res) => {
        dispatch({
          type: GET_PAYLIST,
          data: res.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: ERROR,
          data: error.message,
        });
      });
  };
};

export const GetCafeteriaDetail = (badge, invoiceID) => {
  const config = {
    headers: {
      "content-type": "application/json",
    },
  };
  return async (dispatch) => {
    dispatch({
      type: PAYROLL_LOADING,
    });
    await axios
      .post(
        //`/api/chatbot/cafeteriaDetail`,
        `https://prod.solaria.tech/erp/orders/getDetailOrderClient?api_token=Rdzfso3HT8wg27waRMCiURkc6mF2J4cPlMWTaiC4jeWq6RO90ha1N1Okgac9`,
        { badgeUser: `01${badge}`, invoiceID: invoiceID },
        config
      )
      .then((res) => {
        dispatch({
          type: GET_CAFETERIA_DETAIL,
          data: res.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: ERROR,
          data: error.message,
        });
      });
  };
};

export const GetYearBonus = (badge) => {
  const config = {
    headers: {
      "content-type": "application/json",
    },
  };
  return async (dispatch) => {
    dispatch({
      type: PAYROLL_LOADING,
    });
    await axios
      .get(
        //`/api/chatbot/aguinaldo`,
        `https://sykesapifunc.azurewebsites.net/api/aguinaldos?code=0oCtsPZ3IR7szCuENGlpFIxrnAQemrTIRHBJgREs6VGULQNX2BbXsA==&codigo_alternativo=${badge}`,
        config
      )
      .then((res) => {
        dispatch({
          type: GET_YEAR_BONUS,
          data: res.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: ERROR,
          data: error.message,
        });
      });
  };
};

export const ResetStorage = () => {
  return async (dispatch) => {
    dispatch({
      type: RESET_STORAGE,
    });
  };
};

export const GetBonus = (badge, year, month) => {
  const config = {
    headers: {
      "content-type": "application/json",
    },
  };
  return async (dispatch) => {
    dispatch({
      type: PAYROLL_LOADING,
    });    
    dispatch({
      type:RESET_BONUS
    });
    await axios
      .post(
        //`/api/chatbot/bono`,
        `https://sykesapifunc.azurewebsites.net/api/bonos?code=yE-JOLAqOKzSZhjTqprtjFJWI7kJwdKGNTetKXi3FU06AzFumOr4BA==`,
        {
          codcia: 2,
          anio: year,
          mes: month,
          codigoEmpleado: `${badge}`,
        },
        config
      )
      .then((res) => {
        dispatch({
          type: GET_BONUS,
          data: res.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: ERROR,
          data: error.message,
        });
      });
  };
};
